import { useMutation } from "@apollo/client";

import { updateActiveViewMutationDocument } from "./active-view.gql";
import { EVENT_ACTIVE_VIEW_UPDATED, trackActiveViewEvent } from "./tracking";

export interface UseUpdateActiveViewProps {
  onCompleted?: () => void;
  onError?: (e: Error) => void;
}

export const useUpdateActiveView = ({ onCompleted, onError }: UseUpdateActiveViewProps = {}) => {
  const [updateActiveView, { loading, error }] = useMutation(updateActiveViewMutationDocument, {
    onCompleted: onUpdateCompleted,
    onError: onUpdateError,
    update: (_cache, { data }) => {
      const updatedActiveView = data?.updateActiveView;
      if (!updatedActiveView) {
        return;
      }

      trackActiveViewEvent(EVENT_ACTIVE_VIEW_UPDATED, updatedActiveView);
    },
  });

  function onUpdateCompleted() {
    if (onCompleted) {
      onCompleted();
    }
  }
  function onUpdateError(e: Error) {
    if (onError) {
      onError(e);
    }
  }
  return {
    updateActiveView,
    loading,
    error,
  };
};
